import React from "react";
import useEntity from "../../../hooks/useRoleAssignment";
import {
    Box, 
    Paper, 
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Link,
    TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from '@mui/utils';
import {ID} from "../../../../types/global.d";
import EntityListHeader from "./RoleAssignmentListHeader";
import EntityListSearch from "./RoleAssignmentListSearch";
import {useLocation} from "react-router";
import RoleAssignmentListPagination from "./RoleAssignmentListPagination";
import * as Api from "../../../apis/RoleAssignment.api";
import { RoleAssignment } from "../../../types/models/RoleAssignment";
import { PrimaryRoleAssignment } from "../../../types/models/RoleAssignment";
import { usePagination } from '../../../../share';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate.ts";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import MembersGroupLink from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupLink";
import MembersGroupName from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupName";
import RoleLink from "../../../../auth/components/role/RoleDetail/RoleLink";
import RoleName from "../../../../auth/components/role/RoleDetail/RoleName";
import ScopeGroupLink from "../../../../auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupLink";
import ScopeGroupName from "../../../../auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupName";
import { toStringDisplay as toStringGroupType } from "../../../types/models/GroupType.d";

import { PrimaryMembersGroup } from "../../../../auth/types/models/MembersGroup";
import { PrimaryRole } from "../../../../auth/types/models/Role";
import { PrimaryScopeGroup } from "../../../../auth/types/models/ScopeGroup";
import {useTheme} from "@mui/material/styles";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import RoleAssignmentListItemTools from "./RoleAssignmentListItemTools";
import {useStateSession} from "../../../../hooks/useAuth";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Trans } from "@lingui/react/macro";
import {
    mdiLinkVariant,
} from "@mdi/js";
import {
    StyledFillNavLink,
    ToolbarTableCell,
    BigTableRow,
    BigTableHeaderRow,
    SmallTableRow,
    SmallTableHeaderRow,
    StyledTableCell,
    StyledMdiIcon,
} from "../../../../share/components/styled/Table";
import {OrderBy, OrderDirection} from "../../../../types/global.d";

type IProps = {
    showAdd: boolean,
    membersGroupId?: ID,
    roleId?: ID,
    scopeGroupId?: ID,
    };

const RoleAssignmentListItem = (props: IProps) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    
    const session = useStateSession()
    const {showAdd, ...query} = props;

    const { page, pageSize, handleChangePage, handleChangePageSize } = usePagination('RoleAssignment')

    
    
    
    
    

    const [orderBys, setOrderBys] = React.useState<OrderBy[]>([]);

    const toggleOrder = React.useCallback((name: string) => {
        setOrderBys(prev => {
            const current = prev.find(item => item.name === name)
            return [
                {
                    name,
                    direction: current?.direction === OrderDirection.Asc ? OrderDirection.Desc : OrderDirection.Asc
                },
                ...(prev.filter(item => item.name !== name))
            ]
        });
    }, []);

    const { data: dataSimple = {
        items: [],
        totalItems: 0,
        page,
        pageSize,
        numPages: 0
    }, 
        isLoading: isLoadingSimple,
        isFetching: isFetchingSimple,
        refetch: refetchSimple,
    } =
          Api.useGetRoleAssignmentPresentationQuery({
                  list: { page, pageSize },
                  filter: {
                    membersGroupIdRefs: (PrimaryMembersGroup.fromQuery(query.membersGroupId)) ? [ PrimaryMembersGroup.fromQuery(query.membersGroupId) ] : [],
                    roleIdRefs: (PrimaryRole.fromQuery(query.roleId)) ? [ PrimaryRole.fromQuery(query.roleId) ] : [],
                    scopeGroupIdRefs: (PrimaryScopeGroup.fromQuery(query.scopeGroupId)) ? [ PrimaryScopeGroup.fromQuery(query.scopeGroupId) ] : [],
                    orderBys,
                  },
              })
    
    const {data, isLoading, isFetching, refetch} =
        {
                data: dataSimple,
                isLoading: isLoadingSimple,
                isFetching: isFetchingSimple,
                refetch: refetchSimple,
            }

    const routeLocation = useLocation();
    
    const onClickUrl = (entity: RoleAssignment) => routeLocation.pathname.endsWith('role-assignments') ?
        `${PrimaryRoleAssignment.fromEntity(entity).toPath()}`
        :
        `role-assignments/${PrimaryRoleAssignment.fromEntity(entity).toPath()}`

    const onEditUrl = (entity: RoleAssignment) => `${onClickUrl(entity)}/edit`

    
    
    return React.useMemo(() => (
        <Box>
            <Paper>
                <EntityListHeader showAdd={showAdd} {...query}/>
                
                <TableContainer>

                    


                    

                    

                    

                    
        
                    
                    {isSmallScreen ?
                        <Table stickyHeader data-testid="RoleAssignment-entity-list" size="small">
                            <TableHead>
                                <SmallTableHeaderRow>
                                    
                                        
                                        
                                        
                                    

                                    
                            { query.membersGroupId ?
                                <></>
                                :
                            
                                <StyledTableCell align="left">
                                    
                                    <TableSortLabel
                                        active={ orderBys.find((item) => item.name === 'membersGroupId') }
                                        direction={ orderBys.find((item) => item.name === 'membersGroupId')?.direction || 'asc' }
                                        onClick={() => toggleOrder('membersGroupId')}
                                    >
                                    
                                        <Trans>Members Group</Trans>
                                    
                                    </TableSortLabel>
                                    
                                </StyledTableCell>
                            }
                            
                        
                    
                                    
                                    
                            <StyledTableCell align="center">
                                
                                <TableSortLabel
                                    active={ orderBys.find((item) => item.name === 'createdAt') }
                                    direction={ orderBys.find((item) => item.name === 'createdAt')?.direction || 'asc' }
                                    onClick={() => toggleOrder('createdAt')}
                                >
                                
                                    <Trans>Created At</Trans>
                                
                                </TableSortLabel>
                                
                            </StyledTableCell>
                        
                    
                                    
                                    
                                </SmallTableHeaderRow>
                            </TableHead>
                            <TableBody>
                                { data.items.map((item) => (
                                    <SmallTableRow
                                        hover={true}
                                        key={ PrimaryRoleAssignment.fromEntity(item).toPath() }
                                    >
                                        
                        
                        
                            
                            
                            
                        
                        { query.membersGroupId ? <></> :
                        

                        <TableCell
                            scope="row"
                            align="left"
                        >
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                                <Typography component="div" sx={ { fontWeight: 'bold', } }>
                                    { item.membersGroupId ?
                                        <>
                                            
                        
                        
                        <MembersGroupName id={ item.membersGroupId }/>
                        
                        
                    
                                        </>
                                        :
                                        '-'
                                    }
                                </Typography>
                                
                            
                                <Typography component="div" variant="body1">
                                    { item.roleId &&
                                            
                                        <>
                                        <Trans>Role</Trans>:&nbsp;
                                        
                                        <RoleName id={ item.roleId }/>
                                </>
                                
                                }
                                </Typography>
                                
                            
                            </Link>
                        </TableCell>
                        }
                        

                    
                        
                    
                        
                        <TableCell
                            scope="row"
                            align="center"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        {displayDateTime(item.createdAt) }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                        
                    
                        
                    
                                    </SmallTableRow>
                                ))}
                            </TableBody>
                        </Table>
                        :
                    
                        <Table stickyHeader data-testid="RoleAssignment-entity-list" size="small">
                            <TableHead>
                                <BigTableHeaderRow>
                                    
                                    
                                    
                                    { query.membersGroupId ?
                                        <></>
                                        :
                                        <StyledTableCell align="left">
                                            
                                            <TableSortLabel
                                                active={ orderBys.find((item) => item.name === 'membersGroupId') }
                                                direction={ orderBys.find((item) => item.name === 'membersGroupId')?.direction || 'asc' }
                                                onClick={() => toggleOrder('membersGroupId')}
                                            >
                                            
                                                <Trans>Members Group</Trans>
                                            
                                            </TableSortLabel>
                                            
                                        </StyledTableCell>
                                    }
                                    
                                    
                                    
                                    
                                    { query.roleId ?
                                        <></>
                                        :
                                        <StyledTableCell align="left">
                                            
                                            <TableSortLabel
                                                active={ orderBys.find((item) => item.name === 'roleId') }
                                                direction={ orderBys.find((item) => item.name === 'roleId')?.direction || 'asc' }
                                                onClick={() => toggleOrder('roleId')}
                                            >
                                            
                                                <Trans>Role</Trans>
                                            
                                            </TableSortLabel>
                                            
                                        </StyledTableCell>
                                    }
                                    
                                    
                                    
                                    
                                    { query.scopeGroupId ?
                                        <></>
                                        :
                                        <StyledTableCell align="left">
                                            
                                                <Trans>Scope Group</Trans>
                                            
                                        </StyledTableCell>
                                    }
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="center">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'createdAt') }
                                            direction={ orderBys.find((item) => item.name === 'createdAt')?.direction || 'asc' }
                                            onClick={() => toggleOrder('createdAt')}
                                        >
                                        
                                            <Trans>Created At</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                </BigTableHeaderRow>
                            </TableHead>
                            <TableBody>
                                { data.items.map((item) => (
                                    <BigTableRow
                                        hover={true}
                                        key={ PrimaryRoleAssignment.fromEntity(item).toPath() }
                                    >
                                        
                                        
                                        
                        { query.membersGroupId ? <></> :
                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            
                        
                        
                        <MembersGroupLink id={ item.membersGroupId } icon={<StyledMdiIcon d={mdiLinkVariant} />}/>
                        
                        
                    
                            
                        </TableCell>
                        
                        }
                        
                    
                                        
                                        
                                        
                                        
                        { query.roleId ? <></> :
                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            
                        
                        
                        <RoleLink id={ item.roleId } icon={<StyledMdiIcon d={mdiLinkVariant} />}/>
                        
                        
                    
                            
                        </TableCell>
                        
                        }
                        
                    
                                        
                                        
                                        
                                        
                        { query.scopeGroupId ? <></> :
                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            
                        
                        
                        <ScopeGroupLink id={ item.scopeGroupId } icon={<StyledMdiIcon d={mdiLinkVariant} />}/>
                        
                        
                    
                            
                        </TableCell>
                        
                        }
                        
                    
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="center"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        {displayDateTime(item.createdAt) }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        <ToolbarTableCell align="center" width="15%">
                                            <RoleAssignmentListItemTools data={ item }
                                                                               onClickUrl={onClickUrl(item)} onEditUrl={onEditUrl(item)}
                                                                                />
                                        </ToolbarTableCell>
                                    </BigTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    }
                    
            
                    { !data.totalItems && !isLoading && !isFetching &&
                        <Typography
                            sx={ { flex: '1 1 100%', padding: "2em", } }
                            component="div"
                        >
                            <Trans>No Role Assignments</Trans>
                        </Typography>
                    }
                    { (isLoading || isFetching) &&
                        <GradientCircularProgress/>
                    }
                </TableContainer>
                <RoleAssignmentListPagination
                    totalItems={ data.totalItems }
                    page={Number(page)}
                    pageSize={pageSize}
                    handleChangePage={handleChangePage}
                    handleChangePageSize={handleChangePageSize}
                />
            </Paper>
        </Box>
    ), [isLoading, isFetching,isSmallScreen, data, page, pageSize, onClickUrl,  onEditUrl])
}

export default RoleAssignmentListItem;
